import { render, staticRenderFns } from "./log-screenshots.vue?vue&type=template&id=8b8eef54&scoped=true&"
import script from "./log-screenshots.vue?vue&type=script&lang=js&"
export * from "./log-screenshots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8eef54",
  null
  
)

export default component.exports